<!--
 * @Author: your name
 * @Date: 2019-11-15 18:37:44
 * @LastEditTime: 2022-03-25 11:23:52
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /zhulogic-design-cloud-next/src/components/header.vue
-->
<template>
  <div class="header" v-if="show">
    <common-nav
      :userInfo="userInfo"
      :ossUrl="ossPrefix"
      :baseUrl="baseUrl"
      :msgCount="unReadMsg"
      introLS="complete"
      :filePolicy="filePolicy"
      :fileType="3"
      :VUE_APP_COOKIE_DOMAIN="VUE_APP_COOKIE_DOMAIN"
      :stageUrl="VUE_APP_STAGE_BASIC_URL"
      thisUrl="next"
      @exit="exitHandle"
      @signinHandle="signin"
      @authentication="authentication"
      @search="handleSearch"
      :isToken="isToken"
    ></common-nav>
  </div>
</template>
<script>
import { getBase64 } from "../utils";
import { Token, ClearToken } from "../utils/token.js";
import axios from "axios";
import { userInfo } from "os";
import { mapGetters } from "vuex";
import CommonNav from "./packages/components/nav/nav.vue";
import Cookie from "js-cookie";
export default {
  components: {
    CommonNav,
  },
  name: "header",
  data() {
    return {
      show: true,
      VUE_APP_COOKIE_DOMAIN: process.env.VUE_APP_COOKIE_DOMAIN,
      VUE_APP_STAGE_BASIC_URL: process.env.VUE_APP_STAGE_BASIC_URL,
      filePolicy: "",
      baseUrl: {
        baseOld: process.env.VUE_APP_OLD_BASIC_URL,
        baseNext: process.env.VUE_APP_NEXT_BASIC_URL,
        baseNuxt: process.env.VUE_APP_NUXT_BASIC_URL,
        baseMall: process.env.VUE_APP_MALL_URL,
        baseDomain: process.env.VUE_APP_COOKIE_DOMAIN,
      },
      isToken: false,
    };
  },
  methods: {
    // 退出， 清除token
    exitHandle() {
      ClearToken();
      this.$store.dispatch("getUserInfo");
      this.isToken = Cookie.get("ZHULOGIC_TOKEN") ? true : false;
    },

    async getOssKey(type) {
      let res = await axios.get(`/designer_api/files/policy?type=${type}`);
      this.filePolicy = res;
    },

    // 签到
    signin() {
      axios.post(`/designer_api/user/signin`).then((res) => {
        this.$Message.success("签到领蛋成功");
        this.$store.dispatch("getUserInfo");
        this.$emit("global:eggSignle");
      });
    },
    // 认证
    authentication() {
      window.location.href = this.baseUrl.baseNext + "/certification";
    },
    /* first ajax */
    first_ajax() {
      if (Token()) {
        this.$store.dispatch("getUserInfo");
        this.$store.dispatch("getAddress");
        this.$store.dispatch("getBlance");
      }
    },
    // 全局搜索
    handleSearch(val) {
      window.location = `${this.baseUrl.baseNuxt}/search?keyword=${val}`;
    },
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo;
    },
    ...mapGetters(["unReadMsg"]),
  },
  watch: {
    $route(to, from) {
      this.first_ajax();
    },
  },
  created() {
    this.getOssKey(3);
    this.isToken = Cookie.get("ZHULOGIC_TOKEN") ? true : false;
  },
};
</script>
